import {
  ClockIcon,
  ExclamationTriangleIcon,
} from '@heroicons/react/24/outline';

import { TreatmentRecordRequestAuditLogSchema } from '@/services/api/generated/treatmentRecordRequestsService';

import { ActivityLogItem } from './ActivityLogItem';

interface ActivityLogTimelineProps {
  auditLogs: TreatmentRecordRequestAuditLogSchema[];
  isLoading?: boolean;
  error?: any;
}

export const ActivityLogTimeline = ({
  auditLogs,
  isLoading = false,
  error,
}: ActivityLogTimelineProps) => {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center p-8">
        <div className="flex items-center gap-2 text-sm text-gray-500">
          <ClockIcon className="h-4 w-4 animate-spin" />
          Loading activity log...
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center p-8">
        <div className="flex items-center gap-2 text-sm text-red-600">
          <ExclamationTriangleIcon className="h-4 w-4" />
          Failed to load activity log
        </div>
      </div>
    );
  }

  if (auditLogs.length === 0) {
    return (
      <div className="text-center py-8 text-gray-500">
        <ClockIcon className="w-6 h-6 mx-auto mb-2 text-gray-400" />
        <p className="text-sm">No activity recorded yet</p>
      </div>
    );
  }

  // Sort by created_at (oldest first)
  const sortedLogs = [...auditLogs].sort((a, b) => {
    const dateA = new Date(a.created_at || '').getTime();
    const dateB = new Date(b.created_at || '').getTime();
    return dateA - dateB;
  });

  return (
    <div className="flow-root">
      <ul className="space-y-4">
        {sortedLogs.map((auditLog, index) => (
          <ActivityLogItem
            key={auditLog.id}
            auditLog={auditLog}
            isLast={index === sortedLogs.length - 1}
          />
        ))}
      </ul>
    </div>
  );
};
